export interface MobileUser {
  workerId: string
  username: string | null
  name: string | null
  surname: string | null
  email: string | null
  workTitle: string | null
  personalNumber: string | null
  titleSelector: number
  employeeId: string
  countryId: string
  lidarEnabled: boolean
  sendVideo: boolean
  canAddCar: boolean
  canAddMachine: boolean
  rtkLoginId: string | null
  isAsfalt: number
  active: boolean
  countryName: string | null
  employeeName: string | null
  phone: string | null
  employeeNumber: string | null
  rtkLoginName: string | null
  lastAppVersion: string | null
}

export interface MobileOptions {
  enabled: boolean
  countries: { id: string; name: string }[]
  rtkLogins: { id: string; name: string }[]
  titles: number[]
  passwordLength: number
}

export interface MobileEmployeeHit {
  id: string
  name: string
  number: string | null
  company: string | null
}

export const TITLES: { id: number; key: 'titleWorker' | 'titleEmployee' | 'titleTranslation' | 'titleBauleiter' | 'titleManager' | 'titleStorage' | 'titleCeo' | 'titleBigCeo' | 'titleKolona' }[] = [
  { id: 0, key: 'titleWorker' },
  { id: 13, key: 'titleEmployee' },
  { id: 71, key: 'titleTranslation' },
  { id: 1, key: 'titleBauleiter' },
  { id: 2, key: 'titleManager' },
  { id: 3, key: 'titleStorage' },
  { id: 10, key: 'titleCeo' },
  { id: 11, key: 'titleBigCeo' },
  { id: 12, key: 'titleKolona' },
]

export const FILTERS: { id: number; key: typeof TITLES[number]['key'] | 'titleAll' }[] = [
  { id: 999, key: 'titleAll' },
  { id: 1, key: 'titleBauleiter' },
  { id: 0, key: 'titleWorker' },
  { id: 2, key: 'titleManager' },
  { id: 71, key: 'titleTranslation' },
  { id: 10, key: 'titleCeo' },
]

export function fullName(u: Pick<MobileUser, 'name' | 'surname'>) {
  return [u.name, u.surname].filter(Boolean).join(' ').trim()
}

export function suggestUsername(name: string, surname: string) {
  const raw = `${name}.${surname}`.toLowerCase()
  let cleaned = [...raw].filter((c) => /[a-z0-9.]/i.test(c)).join('')
  while (cleaned.includes('..')) cleaned = cleaned.replaceAll('..', '.')
  return cleaned.replace(/^\.+|\.+$/g, '')
}
